export const dashToPascalCase = (str) => str
    .toLowerCase()
    .split('-')
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('');
export const camelToDashCase = (str) => str.replace(/([A-Z])/g, (m) => `-${m[0].toLowerCase()}`);
//# sourceMappingURL=case.js.map


// WEBPACK FOOTER //
// ./~/@waypoint/react-components/dist/react-component-lib/utils/case.js